import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery, NetworkStatus, useMutation } from '@apollo/client';
import { useEffect } from 'react';

import {
  CREATE_PRODUCT_VISIT,
  GET_PRODUCT,
  LIST_BOOKS,
  LIST_SIMILAR_PRODUCTS,
} from './queries';

import ProductPreviewCard from '../../components/ProductPreviewCard';
import BookList from './BookList';
import CollaborationPage from '../../containers/CollaborationPage';

import Box from '../../components/layout/Box';
import ProductList from '../../components/ProductList';

import './styles.css';

const Product = () => {
  const [sp] = useSearchParams();
  const i = sp.get('i');
  const id = i ? parseInt(i, 10) : null;

  const navigate = useNavigate();

  const onNewClick = () => {
    navigate(`/new?mode=search&i=${id}`);
  };

  const product = useQuery(GET_PRODUCT, {
    variables: {
      id,
    },
  });

  const [createProductVisit] = useMutation(CREATE_PRODUCT_VISIT);

  const similarProducts = useQuery(LIST_SIMILAR_PRODUCTS, {
    variables: {
      productId: id,
    },
  });

  const limit = 10;

  const books = useQuery(LIST_BOOKS, {
    notifyOnNetworkStatusChange: true,
    variables: {
      productId: id,
      pagination: {
        offset: 0,
        limit: 10,
      },
      sorting: {
        orderBy: 'updatedAt',
        order: 'DESC',
      },
    },
  });

  useEffect(() => {
    const scrollContainer =
      document.getElementsByClassName('scrollContainer')[0];
    scrollContainer.scrollTo(0, 0);
  }, [product?.data?.getProduct?.id]);

  useEffect(() => {
    createProductVisit({
      variables: {
        input: {
          productId: id,
        },
      },
    });
  }, []);

  const combinedRefetch = () => {
    product.refetch();
    books.refetch();
  };

  const queries = [books, product];
  const loading = queries.some(
    (q) =>
      q.loading &&
      (q.networkStatus === NetworkStatus.loading ||
        q.networkStatus === NetworkStatus.setVariables),
  );
  const error = queries.some((q) => q.error);

  return (
    <CollaborationPage
      loading={loading}
      error={error}
      onRetry={combinedRefetch}
      className="pt-1"
    >
      <ProductPreviewCard
        useTitle
        product={product?.data?.getProduct}
        onNewClick={onNewClick}
      />
      <Box className="mt-5">
        <BookList
          limit={limit}
          onNewClick={onNewClick}
          items={books?.data?.listBooks || []}
          loading={books?.loading}
          networkStatus={books?.networkStatus}
          fetchMore={books?.fetchMore}
          product={product?.data?.getProduct}
          affiliateProducts={product?.data?.getProduct?.affiliateProducts}
        />
      </Box>

      {similarProducts?.data?.listSimilarProducts?.length > 0 && (
        <ProductList
          title="Liknande artiklar"
          items={similarProducts?.data?.listSimilarProducts || []}
          loading={similarProducts?.loading}
        />
      )}
    </CollaborationPage>
  );
};

export default Product;
